export default "/packs/images/true-adventure~1dac76a532d7bd2f4073ae318c8ad04b.png";